import { useEffect, useState, useRef } from "react";
import "./TestimonialCarousel.css";
import { useSelector } from "react-redux";
import Carousel from "react-spring-3d-carousel";
import { config } from "react-spring";
import TestimonialContent from "../testimonial-content/TestimonialContent";
import {
  CarouselProvider,
  Slider,
  Slide,
  Dot,
  ButtonBack,
  ButtonNext,
} from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";
// import TestimonialBanner from "../../../assets/images/testimonial_img.png";
import { LazyLoadImage } from "react-lazy-load-image-component";
import MediaAssets from "assets";

const TestimonialCarousel = () => {
  const testimonials = useSelector((state: any) => {
    return state?.preLoginPageManagement?.pageData
      ?.pageManagementsOrTestimonials;
  });
  const testimonialsHeading = useSelector((state: any) => {
    return state?.preLoginPageManagement?.pageData?.page?.testimonialsHeading;
  });

  const [slides, setSlides] = useState<any>([]);

  const checkMediaType = (mediaFile: string) => {
    const lowercasedString = mediaFile?.toLowerCase();

    switch (true) {
      case lowercasedString?.includes("youtube"):
        return "youtube";
      case lowercasedString?.includes(".mp4"):
      case lowercasedString?.includes(".mov"):
      case lowercasedString?.includes(".avi"):
      case lowercasedString?.includes(".mkv"):
        return "video";
      default:
        return "image";
    }
  };

  useEffect(() => {
    if (testimonials) {
      const sliderContent: any = [];
      testimonials?.map((data: any, index: number) => {
        const mediaType = checkMediaType(data?.testimonialsMedia);
        const Url = data.testimonialsMedia
          ? data.testimonialsMedia
          : MediaAssets.TestimonialBanner;

        const sliderItems = {
          key: index,
          content: (
            <TestimonialContent
              companyName={data?.companyName}
              personName={`${data?.firstName} ${data?.lastName}`}
              personDesignation={data?.designation}
              mediaUrl={Url}
              mediaType={mediaType}
            >
              {data?.testimonialContent}
            </TestimonialContent>
          ),
        };

        sliderContent.push(sliderItems);
      });

      setSlides(sliderContent);
    }
  }, [testimonials]);

  const disableButtonsOnMobile = window.innerWidth <= 600;

  const iframeRef = useRef<HTMLIFrameElement | any>(null);

  const [showContent, setShowContent] = useState<boolean>(false);
  const [currentSlide, setCurrentSlide] = useState<number>(0);

  useEffect(() => {
    const handleIframeClick = (event: MouseEvent) => {
      event.stopPropagation();
      if (iframeRef.current) {
        iframeRef.current.contentWindow.postMessage("play", "*");
      }
      setShowContent(!showContent);
    };

    if (iframeRef.current) {
      iframeRef.current?.addEventListener("click", handleIframeClick);
    }

    return () => {
      if (iframeRef.current) {
        iframeRef.current.removeEventListener("click", handleIframeClick);
      }
    };
  }, []);

  const handleSlideChange = (nextSlide: number) => {
    setCurrentSlide(nextSlide);
    setShowContent(false);
    pauseVideoPlayback();
  };

  const pauseVideoPlayback = () => {
    if (iframeRef.current) {
      iframeRef.current.contentWindow?.postMessage("pause", "*");
    }
  };
  const eventLogger = (e: any) => {
    setShowContent(false);
  };

  if (!(testimonials?.length > 0)) {
    return <></>;
  }
  return (
    <>
      <div className="testimonialCarousel">
        <div className="testimonialCarouselHeader">{testimonialsHeading}</div>
        {slides.length > 0 && (
          <Carousel
            slides={slides}
            // goToSlide={number}
            offsetRadius={2}
            showNavigation={!disableButtonsOnMobile}
            animationConfig={config}
            goToSlideDelay={300}
          />
        )}
      </div>

      {/* testimonial mobile screen */}
      <div className="testimonial_carousel_mobile">
        <div className="testimonialCarouselHeader">{testimonialsHeading}</div>
        <div className="testimonail_carousel_main_div">
          <CarouselProvider
            naturalSlideWidth={100}
            naturalSlideHeight={100}
            totalSlides={testimonials?.length}
            isPlaying={true}
            interval={3000}
            infinite={true}
            visibleSlides={1}
            currentSlide={currentSlide}
            dragEnabled={true}
            // onChange={handleSlideChange}
          >
            <Slider
              trayProps={{
                onDrag: eventLogger,
                onMouseOver: eventLogger,
                onMouseEnter: eventLogger,
                onPointerEnter: eventLogger,
              }}
            >
              {testimonials &&
                testimonials.map((testimonial: any, ind: any) => {
                  return (
                    <Slide index={ind} key={ind}>
                      <div>
                        <div>
                          {testimonial?.testimonialsMedia ? (
                            <div
                              style={{
                                width: "100%",
                                height: "100vh",
                                objectFit: "fill",
                              }}
                            >
                              <iframe
                                title="youtube"
                                style={{
                                  position: "relative",
                                  objectFit: "fill",
                                }}
                                width={450}
                                height={450}
                                src={testimonial?.testimonialsMedia}
                                allowFullScreen
                                ref={iframeRef}
                              ></iframe>
                            </div>
                          ) : (
                            <div>
                              <LazyLoadImage
                                src={MediaAssets.TestimonialBanner}
                                style={{
                                  width: "100%",
                                  height: "100vh",
                                }}
                                alt="TestimonialBanner"
                              />
                            </div>
                          )}
                        </div>
                        <div
                          className={`${
                            showContent ? "" : "testimonail_data_details"
                          }`}
                        >
                          <div className="testimonial_user_name_style">
                            {testimonial?.firstName} {testimonial?.lastName}
                          </div>
                          <div className="testimonial_company_name_style">
                            {testimonial?.companyName}
                          </div>
                          <div className="testimonial_designation_style">
                            {testimonial?.designation}
                          </div>
                          <div className="testimonial_testimonial_content_style">
                            {testimonial?.testimonialContent
                              ? testimonial?.testimonialContent
                              : "It was great help from HoABL in collecting my registered documents ,team really comes out of the way to help, really appreciating, awaiting eagerly for future property updates."}
                          </div>
                        </div>
                      </div>
                    </Slide>
                  );
                })}
            </Slider>
          </CarouselProvider>
        </div>
      </div>
    </>
  );
};

export default TestimonialCarousel;
